<template>
  <VueDragResize
    :isActive="true"
    :w="getDimensionEncart.width"
    :h="getDimensionEncart.height"
    :x="getDimensionEncart.left"
    :y="getDimensionEncart.top"
    :isDraggable="isEditable"
    :isResizable="!encart.ligneRegroupementId && isEditable"
    :parentW="getDimensionParent.width"
    :parentH="getDimensionParent.height"
    :gridX="5" :gridY="5"
    @dragging="draging"
    @resizing="resizing"
    class="has-background-light"
    parentLimitation snapToGrid>
    <div class="columns mg-0 encart-chemin-text is-centered">
      <div class="column is-9 has-text-centered has-text-weight-bold has-text-white">
        <p class="is-size-5">
          {{ encart.libelleRegroupement }}
        </p>
        <p class="is-size-6">
          {{ encart.libelleEncart }}
        </p>
        <p v-if="getInfoEncartOnLigne(encart)" class="is-size-6">
          {{ getInfoEncartOnLigne(encart).annonceur }},
          <router-link-blank
            :to="getInfoEncartOnLigne(encart).commande.to"
            :message="getInfoEncartOnLigne(encart).commande.code"
            class="lien is-inline-block">
          </router-link-blank>,
          <router-link-blank v-if="modulePlanMediaActive"
            :to="getInfoEncartOnLigne(encart).planMedia.to"
            :message="getInfoEncartOnLigne(encart).planMedia.code"
            class="lien is-inline-block">
          </router-link-blank>
        </p>
      </div>
      <div v-if="isEditable" class="column is-3 columns mg-0 has-text-centered">
        <div
          v-if="!encart.ligneRegroupementId"
          @click="$emit('editEncart')"
          class="mgr-5px column is-6">
          <b-icon
            icon="pencil-box-outline"
            class="is-cursor-pointer"
            size="is-medium"
            type="is-success"></b-icon>
        </div>
        <div
          @click="$emit('deleteEncart')"
          class="column is-6" >
          <b-icon
            icon="delete-forever"
            class="is-cursor-pointer"
            size="is-medium"
            type="is-danger"></b-icon>
        </div>
      </div>
    </div>
    <div v-if="url" class="has-text-centered">
      <img :src="url" :style="getSizeImage">
    </div>
  </VueDragResize>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import VueDragResize from 'vue-drag-resize';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import { COEFFICIENT_DIMENSION } from '@/configuration/presse/parution/cheminFerConfig';
import calculArrondi from '@/services/calcul/calculArrondi';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');
export default {
  name: 'BlocEncartCheminFer',
  components: {
    VueDragResize,
    RouterLinkBlank,
  },
  props: {
    encart: {
      type: Object,
      required: true,
    },
    page: {
      type: Object,
      required: true,
    },
    lignesCommandes: {
      type: Array,
      required: true,
    },
    url: {
      type: String,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    getDimensionParent() {
      return {
        width: this.page.largeurUtile * COEFFICIENT_DIMENSION,
        height: this.page.hauteurUtile * COEFFICIENT_DIMENSION,
      };
    },
    getDimensionEncart() {
      return {
        width: this.encart.largeur * COEFFICIENT_DIMENSION,
        height: this.encart.hauteur * COEFFICIENT_DIMENSION,
        top: this.encart.decalageMargeHaut * COEFFICIENT_DIMENSION,
        left: this.encart.decalageMargeGauche * COEFFICIENT_DIMENSION,
      };
    },
    getSizeImage() {
      return `
      max-width: ${(this.encart.largeur) * COEFFICIENT_DIMENSION}px!important;
      max-height: ${(this.encart.hauteur) * COEFFICIENT_DIMENSION}px!important;`;
    },
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    draging(newRect) {
      this.encart.decalageMargeHaut = newRect.top / COEFFICIENT_DIMENSION;
      this.encart.decalageMargeGauche = newRect.left / COEFFICIENT_DIMENSION;
    },
    resizing(newRect) {
      this.encart.largeur = calculArrondi(newRect.width / COEFFICIENT_DIMENSION, 0);
      this.encart.hauteur = calculArrondi(newRect.height / COEFFICIENT_DIMENSION, 0);
      const pourcentSurface = (this.encart.largeur * this.encart.hauteur)
        / (this.page.largeur * this.page.hauteur);
      this.encart.ratio = calculArrondi(pourcentSurface * this.page.surface.ratio, 5);
    },
    getInfoEncartOnLigne() {
      const ligne = this.lignesCommandes.find(l => l.id === this.encart.ligneRegroupementId);
      if (!ligne) return null;
      return {
        annonceur: ligne.annonceur,
        commande: {
          title: this.$t('editCheminFer.titleCommande'),
          code: ligne.codeDevisCommande,
          to: { name: 'c.bodac.commandes', params: { id: ligne.devisCommandeId } },
        },
        planMedia: {
          code: ligne.codePlanMedia,
          to: { name: 'c.presse.plan_media', params: { id: ligne.planMediaId } },
        },
      };
    },
  },
  async mounted() {
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
  },
};
</script>
